import Icon from '../components/Icon.vue'

Icon.register({"book":{"width":448,"height":512,"paths":[{"d":"M448 360V24C448 10.7 437.3 0 424 0H96C43 0 0 43 0 96V416C0 469 43 512 96 512H424C437.3 512 448 501.3 448 488V472C448 464.5 444.5 457.7 439.1 453.3 434.9 437.9 434.9 394 439.1 378.6 444.5 374.3 448 367.5 448 360zM128 134C128 130.7 130.7 128 134 128H346C349.3 128 352 130.7 352 134V154C352 157.3 349.3 160 346 160H134C130.7 160 128 157.3 128 154V134zM128 198C128 194.7 130.7 192 134 192H346C349.3 192 352 194.7 352 198V218C352 221.3 349.3 224 346 224H134C130.7 224 128 221.3 128 218V198zM381.4 448H96C78.3 448 64 433.7 64 416 64 398.4 78.4 384 96 384H381.4C379.5 401.1 379.5 430.9 381.4 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/book.js
// module id = null
// module chunks = 